import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import BoatCard from "@/components/BoatCard";

export default function RecommendedBoats() {
  const { t } = useLang();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/recommendations")
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  if (!data) return null;
  const rec = data.recommended || [];
  const oob = data.out_of_budget || [];
  if (rec.length === 0 && oob.length === 0) return null;

  const REASON = {
    zone_and_budget: t.explore.reasonZoneBudget,
    zone: t.explore.reasonZone,
    budget: t.explore.reasonBudget,
    other: t.explore.reasonOther,
  };

  return (
    <section className="mt-12" data-testid="recommended-section">
      <div className="max-w-3xl">
        <p className="eyebrow" data-testid="recommended-eyebrow">{t.explore.recommendedTitle}</p>
        <p className="mt-2 text-slate-600">{t.explore.recommendedSubtitle}</p>
      </div>

      {rec.length > 0 && (
        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14" data-testid="recommended-grid">
          {rec.map((b) => (
            <BoatCard key={b.id} boat={b} testIdPrefix="rec-card" reason={REASON[b.reason_code] || ""} />
          ))}
        </div>
      )}

      {oob.length > 0 && (
        <div className="mt-14" data-testid="recommended-oob">
          <p className="eyebrow text-slate-400">{t.explore.outOfBudgetTitle}</p>
          <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
            {oob.map((b) => (
              <BoatCard
                key={b.id}
                boat={b}
                testIdPrefix="rec-oob-card"
                tone="muted"
                reason={`${t.explore.outOfBudgetTag} +€${Number(b.over_budget_by || 0).toLocaleString()}`}
              />
            ))}
          </div>
        </div>
      )}

      <div className="mt-16 border-t border-slate-100" />
    </section>
  );
}
